<script lang="ts">
    import dayjs from 'dayjs'
    import { createEventDispatcher } from 'svelte'
    import { isEmptyValue, toValidDate } from './zinput-date-value'

    export let value: Date | string = null
    export let disabled = false
    export let required = false
    export let autocomplete: string = null
    export let labeled = false
    export let htmlInput = null

    const dispatch = createEventDispatcher()

    // texto do input nativo ('YYYY-MM-DDTHH:mm'); vazio enquanto data e hora não estão completas
    let _value: string = ''

    // o campo nativo é lido pelo on:input e escrito só por nós — nunca com bind:value. atribuir
    // input.value reinicia os segmentos do campo (dd/mm/aaaa) e apaga o que já foi digitado, e o bind
    // devolvia ao campo justamente o vazio que o navegador reporta enquanto a data está incompleta ou
    // não existe (29/02 do ano 202, no meio de "29/02/2024"). era isso que travava o ano: digitar 1982
    // terminava em 1902, porque cada dígito recomeçava o segmento.
    // enquanto o campo tem o foco o texto é do usuário; o acerto fica pro blur.
    let focused = false

    $: importValue(value)

    function importValue(v: Date | string) {
        const date = toValidDate(v)
        const text = date ? dayjs(date).format('YYYY-MM-DDTHH:mm') : ''
        if (text !== _value && !focused) _value = text
        // valor inválido vindo de fora vira vazio — nunca "Invalid Date" no campo nem no valor
        if (!date && !isEmptyValue(v)) value = null
    }

    function exportValue(text: string) {
        if (!text) {
            if (!isEmptyValue(value)) value = null
            return
        }
        // "YYYY-MM-DDTHH:mm" (sem fuso) já é lido como horário local, diferente de "YYYY-MM-DD" puro (lido
        // como UTC) — por isso aqui não há correção de fuso
        const date = toValidDate(text)
        if (!date) return
        const current = toValidDate(value)
        if (current && current.getTime() === date.getTime()) return
        value = date
    }

    function onInput() {
        exportValue(htmlInput?.value ?? '')
    }

    function onKeyup(ev) {
        dispatch('keyup', ev)
    }
    function onChange(ev) {
        dispatch('change', ev)
    }
    function onFocus(ev) {
        focused = true
        dispatch('focus', ev)
    }
    function onBlur(ev) {
        focused = false
        importValue(value)
        dispatch('blur', ev)
    }
</script>

<input
    {autocomplete}
    {required}
    bind:this={htmlInput}
    type="datetime-local"
    class="zinput_input zinput_input_labeled-{labeled}"
    value={_value}
    {disabled}
    on:input={onInput}
    on:keyup={onKeyup}
    on:change={onChange}
    on:focus={onFocus}
    on:blur={onBlur}
/>
